import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { EcoCostService } from 'src/app/services/eco-cost/eco-cost.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'pro-eco-cost-toggle',
  templateUrl: './eco-cost-toggle.component.html',
  styleUrls: ["./eco-cost-toggle.component.css"]
})
export class EcoCostToggleComponent implements OnInit, OnDestroy{
  @Input() isFinancialCost: boolean;
  isProCarbonoMode: boolean = environment.proCarbono;
  private destroy$ = new Subject<void>();

  constructor(private ecoCostService: EcoCostService) {}
  
  ngOnInit(): void {
    this.ecoCostService.isFinancialCost$.pipe(takeUntil(this.destroy$))
      .subscribe((isFinancialCost) => {
        this.isFinancialCost = isFinancialCost;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  
  toggleValue() {
    if(this.isProCarbonoMode) this.ecoCostService.toggleValue();
  }
}
